import { render, staticRenderFns } from "./SessionDetailsTab.vue?vue&type=template&id=99d32ff8&scoped=true&"
import script from "./SessionDetailsTab.vue?vue&type=script&lang=js&"
export * from "./SessionDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d32ff8",
  null
  
)

export default component.exports